// src/components/Footer/Footer.js

import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.css";

import logo from "../../assests/logo.jpeg";

import {
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope
} from "react-icons/fa";

function Footer() {
  const navigate = useNavigate();

  /* GO HOME TOP */
  const goHome = () => {
    navigate("/");
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  /* GO PAGE TOP */
  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="footer-section">

      {/* TOP FOOTER */}
      <div className="footer-container">

        {/* COLUMN 1 */}
        <div className="footer-col">

          {/* CLICKABLE LOGO + TITLE */}
          <div
            className="footer-brand clickable-brand"
            onClick={goHome}
          >
            <img
              src={logo}
              alt="Rootly Logo"
              className="footer-logo"
            />

            <h2>Rootly Homoeopathy</h2>
          </div>

          <p className="footer-text">
            Healing from the root up with natural, safe and personalized care
            for you and your family.
          </p>

          <div className="footer-social">

            <a
              href="https://www.instagram.com/rootly_homoeopathy2026/"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>

          </div>

        </div>

        {/* COLUMN 2 */}
        <div className="footer-col">

          <h3>Quick Links</h3>

          <Link to="/" onClick={goTop}>Home</Link>
          <Link to="/about" onClick={goTop}>About</Link>
          <Link to="/services" onClick={goTop}>Services</Link>
          <Link to="/appointment" onClick={goTop}>Book Appointment</Link>

        </div>

        {/* COLUMN 3 */}
        <div className="footer-col">

          <h3>Our Services</h3>

          <p>Skin Complaints</p>
          <p>PCOD / Thyroid</p>
          <p>Fertility Care</p>
          <p>Allergy Care</p>

        </div>

        {/* COLUMN 4 */}
        <div className="footer-col">

          <h3>Contact Us</h3>

          <p>
            <FaMapMarkerAlt /> Online Consultation
          </p>

          <p>
            <FaPhoneAlt /> +91 93917 60160
          </p>

          <p>
            <FaEnvelope /> rootlyhomoeopathy2026@gmail.com
          </p>

          <a
            href="https://wa.me/919391760160"
            target="_blank"
            rel="noreferrer"
            className="footer-btn"
          >
            WhatsApp Now
          </a>

        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">

        {/* LEFT */}
        <p>
          © 2026 Rootly Homoeopathy. All Rights Reserved.
        </p>

        {/* CENTER */}
        <div className="footer-dev">

          <span>Developed by</span>

          <a
            href="https://www.venkatesh-pothamsetty.com/"
            target="_blank"
            rel="noreferrer"
          >
            Venkatesh Pothamsetty
          </a>

        </div>

        {/* RIGHT */}
        <div className="footer-links">

          <Link
            to="/privacy"
            onClick={goTop}
          >
            Privacy Policy
          </Link>

          <span>|</span>

          <Link
            to="/credits"
            onClick={goTop}
          >
            Credits
          </Link>

        </div>

      </div>

    </footer>
  );
}

export default Footer;